if (
    $('#heroVideo').length &&
    $('#heroVideo source').attr('data-src-mobile') != undefined &&
    $('#heroVideo source').attr('data-src-desktop') != undefined
) {
    const desktopSrc = $('#heroVideo source').attr('data-src-desktop');
    const mobileSrc = $('#heroVideo source').attr('data-src-mobile');

    function updateHeroVslSrc() {
        if (window.innerWidth < 768) {
            if (videojs('heroVideo').src() == desktopSrc) {
                videojs('heroVideo').src({ src: mobileSrc });
            }
        } else {
            if (videojs('heroVideo').src() == mobileSrc) {
                videojs('heroVideo').src({ src: desktopSrc });
            }
        }
    }

    if (desktopSrc != mobileSrc) {
        updateHeroVslSrc();

        $(window).on('resize', function () {
            updateHeroVslSrc();
        });
    }
}

if ($('#heroVideo').length && window.innerWidth < 1024) {
    let touchmoved;

    if ($('#heroVideo video').get(0).paused) {
        videojs('heroVideo').play();
    }

    $('#heroVideo').on('touchend', function () {
        if (touchmoved != true) {
            if ($('#heroVideo video').get(0).paused) {
                videojs('heroVideo').play();
            } else {
                videojs('heroVideo').pause();
            }
        }
    }).on('touchmove', function () {
        touchmoved = true;
    }).on('touchstart', function () {
        touchmoved = false;
    });
}